import { render, staticRenderFns } from "./SoalImport.vue?vue&type=template&id=2bd415d5&scoped=true"
import script from "./SoalImport.vue?vue&type=script&lang=js"
export * from "./SoalImport.vue?vue&type=script&lang=js"
import style0 from "./SoalImport.vue?vue&type=style&index=0&id=2bd415d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd415d5",
  null
  
)

export default component.exports